import { FREE_SHIP_THRESHOLD } from "@/context/CartContext";


export default function Shipping() {
  return (
    <div className="pt-32 pb-32 max-w-[720px] mx-auto px-4 md:px-8 min-h-[60vh]" data-testid="shipping-page">
      <h1 className="font-display text-5xl md:text-6xl uppercase mb-8">Shipping</h1>
      <p className="text-lg text-gray-700 leading-relaxed">
        Free shipping on all orders over <span className="font-bold text-ink">${FREE_SHIP_THRESHOLD}</span> — for US orders only.
      </p>
    </div>
  );
}
